/**
 * @generated SignedSource<<c91f5d06ed36c8f22343e4d852e7c5b4>>
 * @relayHash 68ca4675a5fc33f83d2b6fad0b42237e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d9a203b75dacab534f5f6942b4eeab9968b032f84026f7d1f9879d26c0bf9593

import type { ConcreteRequest } from 'relay-runtime';
export type StudioCustomSkillRendererQuery$variables = {
  contextAri: string;
  skillAri: string;
};
export type StudioCustomSkillRendererQuery$data = {
  readonly graphIntegration_skill: {
    readonly description: string;
    readonly instructions: string;
    readonly name: string;
    readonly uiMetadata: {
      readonly displayName: string;
      readonly helpText: string | null;
    };
  } | null;
};
export type StudioCustomSkillRendererQuery = {
  response: StudioCustomSkillRendererQuery$data;
  variables: StudioCustomSkillRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contextAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skillAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "contextAri",
    "variableName": "contextAri"
  },
  {
    "kind": "Variable",
    "name": "skillAri",
    "variableName": "skillAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "description"
},
v5 = {
  "kind": "ScalarField",
  "name": "instructions"
},
v6 = {
  "concreteType": "GraphIntegrationSkillUiMetadata",
  "kind": "LinkedField",
  "name": "uiMetadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "kind": "ScalarField",
      "name": "helpText"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "StudioCustomSkillRendererQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "GraphIntegrationSkill",
        "kind": "LinkedField",
        "name": "graphIntegration_skill",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StudioCustomSkillRendererQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "GraphIntegrationSkill",
        "kind": "LinkedField",
        "name": "graphIntegration_skill",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d9a203b75dacab534f5f6942b4eeab9968b032f84026f7d1f9879d26c0bf9593",
    "metadata": {},
    "name": "StudioCustomSkillRendererQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7582acc7a5c3d90b2c5887b42aabb678";

export default node;
